module.exports = __webpack_public_path__ + "img/ic_home_right_arrow.345e8e05.svg";